module.exports = __webpack_public_path__ + "static/media/frozen2.fceea460.png";